module.exports = __webpack_public_path__ + "img/picture_teachvideo2@2x.698fc137.png";